
import { defineComponent, nextTick, PropType, ref, watch } from 'vue'
import { ProcessInfos } from '@/views/dashboard/policy/process-control/process-control.service'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'

export default defineComponent({
  components: { BtnIcon },
  props: {
    modelValue: {
      type: Array as PropType<ProcessInfos[]>,
      default: []
    },
    cols: {
      type: Array as PropType<string[]>,
      default: () => (['name', 'path', 'md5', 'signature'])
    }
  },

  setup (props, context) {
    const tableNode = ref()
    const compData = ref<ProcessInfos[]>([])

    function delProcess (index: number) {
      compData.value.splice(index, 1)
    }

    function scrollTableToBottom () {
      tableNode.value.$el.querySelectorAll('.el-table__body-wrapper').forEach((dom: any) => {
        dom.scrollTop = 99999999999
      })
    }

    async function addProcess () {
      compData.value.push({})
      await nextTick()
      scrollTableToBottom()
    }

    watch(compData, (value) => {
      context.emit('update:modelValue', value)
    }, { deep: true })

    watch(() => props.modelValue, (newVal, oldValue) => {
      if (JSON.stringify(newVal) !== JSON.stringify(oldValue)) {
        compData.value = props.modelValue
      }
    }, { immediate: true })

    return {
      tableNode,
      compData,
      delProcess,
      addProcess,
    }
  }
})
